import { BundlerProviderLike } from './bundler';

export interface PaymasterApi {
  url: string;
  context?: any;
}

export enum Factory {
  ETHERSPOT = 'etherspot',
}

export interface SdkOptions {
  etherspotWalletAddress?: string;
  chainId: number;
  apiKey: string;
  sessionKey: string;
  rpcProviderUrl?: string;
  factoryWallet?: Factory;
  walletFactoryAddress?: string;
  entryPointAddress?: string;
  bundlerProvider?: BundlerProviderLike;
  index?: number;
}
